export class BooleanUtil {
    public static isTrue(value: unknown, defaultValue?: boolean): boolean {
        if (value == undefined && defaultValue != undefined) {
            return defaultValue;
        }

        if (typeof value === "boolean") {
            return value;
        }

        if (typeof value === "number") {
            return value !== 0;
        }

        if (typeof value === "string") {
            const v = value.trim().toLowerCase();
            return v === "true" || v === "1" || v === "yes";
        }

        return false;
    }
}
